import { render } from "./Form.vue?vue&type=template&id=2fd14246&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=2fd14246&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fd14246"

export default script